var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-bar"},[_c('div',[_c('div',{staticClass:"title"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.total)?_c('div',[_vm._v("("+_vm._s(_vm.total)+" deals)")]):_vm._e()])]),_c('div',[_c('Search')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }